/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import Buttons from '../../components/buttons/buttons'

const CreateActionBtns = ({
  activeButton,
  handleSaveOrSubmit,
  handleUpdate,
  isEditDueout,
  onClose,
  onSaveAsDraft,
  onSubmit,
  type
}) => {
  const [activeTab, setActiveTab] = useState<boolean>(true)
  const [clicked, setClicked] = useState(false)
  useEffect(() =>{
     setActiveTab(activeButton)
  }, [activeButton])
  const handleSaveClick = () => {
    const element = document.getElementById('create-inquiry')
    onSaveAsDraft()
    setClicked(true)
    setTimeout(() => {
      setClicked(false)
      setActiveTab(true)
      element?.focus()
    }, 1000)
  }
  return (
    <ul className='d-flex list-type-none gap-1'>
      <li>
        <Buttons
          className={'btn-border1 btn-border-radius3 poppins-bold  font-0 font-md-12 text-uppercase title-color5 btn-hover'}
          icon='icon-close font-10 pe-md-1 title-color6'
          label='Close'
          onClick={onClose}
          type='button'
        />
      </li>
    { isEditDueout && <li>
        <Buttons
          className={'btn-border1 btn-border-radius3 poppins-bold font-0 font-md-12 text-uppercase title-color5 btn-hover'}
          icon='icon-update font-10 pe-md-1 title-color6'
          label='UPDATE'
          onClick={() => {
            onSubmit()
            handleUpdate()
          }}
          type='button'
        />
      </li>}
     {!isEditDueout && <li>
        <Buttons
          className={`btn-border1 btn-border-radius3 poppins-bold  font-0 font-md-12 text-uppercase title-color5 save-button ${activeTab && !clicked ? 'btn-hover' : ''
            }`} 
          icon='icon-save font-10 pe-md-1 title-color6'
          label='Save As Draft'
          onClick={handleSaveClick}
          type='button'
        />
      </li>}
    { !isEditDueout && <li>
        <Buttons
          className={'btn-border1 btn-border-radius3 poppins-bold  font-0 font-md-12 text-uppercase title-color5 btn-hover'}
          icon='icon-submite font-11 pe-md-1 title-color6'
          label='Submit'
          onClick={() => {
            onSubmit()
            handleSaveOrSubmit()
          }}
          type={type}
        />
      </li>}
    </ul>
  )
}
CreateActionBtns.propTypes = {
  activeButton: PropTypes.bool,
  handleSaveOrSubmit: PropTypes.func,
  handleUpdate : PropTypes.func,
  isEditDueout : PropTypes.bool,
  onClose: PropTypes.func,
  onSaveAsDraft: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  showClose: PropTypes.bool,
  showSaveAsDraft: PropTypes.bool,
  showSubmit: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
}
export default CreateActionBtns
